export const CLEAR_PAGE = 'CLEAR_PAGE';